/** Личный диалог: главный экран — собеседник, не «я». */
export function focusRemoteAsMainIfPrivate(
  remotePeerId: string,
  updateCurrentStream: (peerId: string) => void,
) {
  if (typeof window === "undefined") return;
  if (sessionStorage.getItem("call_chat_type") === "private") {
    updateCurrentStream(remotePeerId);
  }
}

export function focusLocalAsMainIfPrivate(
  localPeerId: string,
  updateCurrentStream: (peerId: string) => void,
) {
  if (typeof window === "undefined") return;
  if (sessionStorage.getItem("call_chat_type") === "private") {
    updateCurrentStream(localPeerId);
  }
}
